export default {
  categoryInfo: {
    mainTitle: '2.El Garanti Sigortası',
    description: {
      title: '2. El Garanti Sigortası Nedir?',
      content: [
        '2. El Garanti Sigortası, sattığınız veya aldığınız araçta oluşabilecek mekanik veya elektrik arızası risklerine karşı bütçenizi ve aracınızı güvence altına alan sigorta ürünüdür.'
      ]
    },
    subContent: {
      title: '2. El Garanti Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            '2. El Garanti Sigortası teminatları sigorta şirketleri arasında farklılık göstermektedir. Genel olarak; ',
          subList: [
            'Motor Teminatı',
            'Diferansiyel ve Şaft Teminatı',
            'Şanzıman Teminatı',
            'Elektrik Teminatı',
            'Yağ Sızdırmazlık ve Contalar Teminatı',
            'Ana ünite kaplamaları teminat kapsamındadır.'
          ]
        }
      ]
    }
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Motor Teminatı Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Marş dişlisi, volan, yağ pompası, krank mili ve yatakları, trigger dişli ve zinciri (trigger kayışı ve diğer kayışlar hariç), kam mili kasnağı, kam mili, kam mili iticileri, kol dişlisi, subap ve gaydlar, pistonlar ve sekmanlar, silindir yuvaları, bağlantı milleri, silindir başlığı, silindir başlık contaları, distribütör tahrik ve tüm dahili burçlar.',
          subList: null
        }
      ]
    },
    {
      title: 'Difransiyel ve Şaft Teminatı Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Difransiyel ve yarım şaftları da içeren aktarma, dış aktarma şaftları, universal bağlantılar ve sabit hız bağlantıları, (körükler hariç). ',
          subList: null
        }
      ]
    },
    {
      title: 'Şanzıman Teminatı Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Düz ve otomatik şanzımanlar ve overdrive üniteleri, yağ soğutucu ve tam otomatik şanzımanlarda ECU (dış bağlantılar ve elektrik bağlantıları hariç)(Mekatronik, Easytronik, Powershift, DSG, EDC vb. yarı otomatik şanzımanlarda kavrama kitleri, aktüatör ve vites seçici motorları bu kapsamın dışındadır).',
          subList: null
        }
      ]
    },
    {
      title: 'Elektrik Teminatı Neleri Kapsar?',
      content: [
        {
          paragraph: 'Alternatör, Marş motoru, fan motoru, elektrikli cam motorları ve kumandaları, elektrikli sunroof motoru, havalandırma motoru ve kumandası (ızgaralar hariç), far ve sinyal kumandaları, ön / arka cam yıkama ve silecek motorları, on-board bilgisayar, sinyal kolları.',
          subList: null
        }
      ]
    },
    {
      title: 'Yağ Sızdırmazlık ve Contalar Teminatı Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Motor, şanzıman ve/veya arka aks gibi ana ünitelerden herhangi birinin arıza sonucu sökülmesinin gerekmesi durumunda herhangi bir yağ sızdırmazlık ünitesi ve/veya contası.',
          subList: null
        }
      ]
    },
    {
      title: 'Ana Ünite Kaplamaları Teminatı Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Motor, şanzıman ve/veya difransiyel arızası durumunda bu arızanın direk sonucu neticesinde gerekebilecek sarf malzemeleri bu kapsama dahildir. (Kaza, donma ve/veya antifriz eksikliği gibi sebeplerle oluşan arızalar hariçtir.)',
          subList: null
        }
      ]
    },
    {
      title: '2. El Garanti Sigortası Teminat Dışı Haller Nedir?',
      content: [
        {
          paragraph:
            'Teminat dışı kalan haller almış olduğunuz sigorta şirketine ve almış olduğunuz poliçe kapsamına göre değişmektedir. Genel olarak 2. El Garanti Sigortasında teminat dışı tutulan durumlar:',
          subList: [
            'Bakım, servis veya tamir eksiklerinden kaynaklı arızalar.',
            'Kaporta ve boya masrafları',
            'Aşınmaya veya yıpranmaya bağlı değişim masrafları.',
            'Arıza sebebiyle 3. Kişiler karşı oluşacak sorumluluklar.',
            'Yanmış veya yapışmış sübaplar.',
            'Yaşa ve kilometreye bağlı performans düşüşleri.',
            'Kronik arızalar ve arızalardan kaynaklı arızalar.',
            'Değer kaybı, kâr kaybı, ölüm ve sakatlık durumlarıdır.'
          ]
        }
      ]
    },
    {
      title: 'Ekspertiz Raporu Olmadan 2. El Garanti Sigortası Yapılır Mı?',
      content: [
        {
          paragraph:
            '2. El garanti sigortasından yararlanabilmek için araca ekspertiz yaptırmak gereklidir. Bundan dolayı ekspertiz olmadan sigorta almanız mümkün değildir.',
          subList: null
        }
      ]
    },
    {
      title: 'Ekspertiz Raporunda Sorunlu Olan Parçalar İçin Teminat Veriliyor Mu?',
      content: [
        {
          paragraph: 'Ekspertiz raporunda sorunlu olarak belirtilen parçalar teminat kapsamı dışında tutulur. Parçalarda oluşan hasar veya parçaların oluşturduğu hasarlar karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: '2. El Garanti Sigortası Kapsamında Kullanım Ömrü Bulunan Parçaları Karşılar Mı?',
      content: [
        {
          paragraph:
            'Kullanım ömrü bulunan parçalar poliçe kapsamı dışında tutulmadır. Kullanım ömrü biten parçalar ve bu parçalardan kaynaklı olan arızalar kapsam dışıdır.',
          subList: null
        }
      ]
    },
    {
      title: '2. El Garanti Sigortası Araç Bedeli Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'Araç bedeli piyasa bulunan aynı kriterlere sahip araçların piyasa bedelleri ve TSB’nin (Türkiye Sigorta Reasürans ve Emeklilik Şirketler Birliği) yayınlamış olduğu araç kasko değer listesine göre hesaplanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: '2. El Garanti Sigortası Ne Zaman Başlar?',
      content: [
        {
          paragraph:
            'Sigortanın yürürlüğe girebilmesi için ekspertiz işleminin yapılması gerekmektedir. Poliçede belirtilen süre içerisinde ekspertiz yapılmadığı takdirde poliçe geçersiz sayılacaktır.',
          subList: null
        }
      ]
    },
    {
      title: '2. El Garanti Sigortasını Kimler Yaptırabilir?',
      content: [
        {
          paragraph:
            'İlk tescil tarihinden itibaren 8 yasından daha küçük veya 160.000 km’yi doldurmamış tüm araçlara 2. El garanti sigortası düzenlenebilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: '2. El Garanti Sigortası Şirketleri Hangileridir?',
      content: [
        {
          paragraph:
            '2. El araç garanti sigortası fiyatlarını değerlendirmek isteyen müşterilerimize Türk Nippon Sigorta güvencesinde en uygun fiyatı sunmaktayız.',
          subList: null
        }
      ]
    },
    {
      title: '2. El Garanti Sigortası Nasıl Yaptırılır?',
      content: [
        {
          paragraph:
            'Satmış olduğunuz veya satın aldığınız aracınızın oluşturabileceği risklerin önüne geçmek için 2. El garanti sigortası yaptırabilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com ekibinden zaman kaybına uğramadan fiyat teklifi alabilirsiniz. Dolduracağınız başvuru formu ile aracınızın oluşturacağı riskleri kontrol altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: '2. El Garanti Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            '2. El garanti sigortası primleri yani fiyatları aracın yaşı, araç kilometresi, üretim yılı, marka ve modeli göre değişmektedir.',
          subList: null
        },
        {
          paragraph:
            'Sizde aracınız için 2. El araç sigortası düşünüyorsanız doğru yerdesiniz. ',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com üzerinden dolduracağınız başvuru formu ile 2. El araç sigortası hakkında detaylı bilgi alabilir, size özel hazırlanmış teklifleri değerlendirebilir ve poliçenizi tanzim edebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
